import { axiosBaseQuery } from "@/shared/api/base-query";
import { streamsApiInstance } from "@/shared/api/axios";
import { createApi } from "@reduxjs/toolkit/query/react";
import { createCameraDailyCache } from "../lib/cache/camera-daily-cache";
import { toast } from "react-hot-toast";

const baseQuery = axiosBaseQuery(streamsApiInstance);
const recordingCamerasCache = createCameraDailyCache<number[]>(
  "dayAvailableRecords"
);

type BaseQueryResponse<T> =
  | { data: T }
  | { error: { status: number; data: unknown } };

export const streamsApi = createApi({
  reducerPath: "streamsApi",
  baseQuery,
  endpoints: (builder) => ({
    getRecordingCameras: builder.query({
      queryFn: async (
        { atTime, storeKey },
        _queryApi,
        _extraOptions,
        fetchWithBQ
      ) => {
        try {
          recordingCamerasCache.clearExpiredCache();

          const cachedData = recordingCamerasCache.get(atTime, storeKey);

          if (cachedData !== null && cachedData.length > 0) {
            return { data: cachedData };
          }

          const response = (await fetchWithBQ({
            url: `/frame_reader/v3/${storeKey}/day_available_records`,
            method: "GET",
            params: {
              at_time: atTime,
            },
          })) as BaseQueryResponse<number[]>;

          if ("data" in response) {
            if (
              !response.data ||
              !Array.isArray(response.data) ||
              response.data.length === 0
            ) {
              toast.error(
                "No recording cameras available for the selected day"
              );
            } else {
              recordingCamerasCache.set(atTime, response.data, storeKey);
            }
          }

          return response;
        } catch (error) {
          return {
            error: {
              status: 500,
              data: error,
            },
          };
        }
      },
    }),
  }),
});

export const { useGetRecordingCamerasQuery } = streamsApi;
